import { connect } from 'react-redux';
import decorate from '../../../utils/decorate';
import { Map } from 'immutable';

import { request as getWidgetSettings } from '../../../modules/system-settings/actions/get-widget-settings';
import { request as putWidgetSettings } from '../../../modules/system-settings/actions/put-widget-settings';

import WidgetSettingsForm from './WidgetSettingsForm.jsx';

function mapStateToProps(state) {
    return {
        data: state.systemSettings.getIn([ 'widgetSettings', 'data' ] ) || Map(),
        status: state.systemSettings.getIn([ 'widgetSettings', 'state' ] ) || 'IN_PROGRESS'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getWidgetSettings() {
            dispatch(getWidgetSettings());
        },

        putWidgetSettings(data) {
            dispatch(putWidgetSettings(data));
        }
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    WidgetSettingsForm
);
